import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AdminShellService {
    public readonly isOpen: WritableSignal<boolean> = signal(false);
}
